import { Component, Inject, Vue } from 'vue-property-decorator';
import { CountryMapVue } from '@/primary/template-sidebar/country-map';
import { CountryAutocompleteVue } from '@/primary/template-sidebar/country-autocomplete';
import { MissionFilterVue } from '@/primary/template-sidebar/mission-filter';
import { ResearchUnitFilterVue } from '@/primary/template-sidebar/research-unit-filter';
import { isMobile } from '@/primary/responsiveUtils';
import { DepartmentFilterVue } from '@/primary/template-sidebar/department-filter';

const MOBILE_BREAKPOINT = 769;

@Component({
  components: { CountryAutocompleteVue, CountryMapVue, MissionFilterVue, DepartmentFilterVue, ResearchUnitFilterVue },
})
export default class TemplateSidebarComponent extends Vue {
  sidebarExpanded = true;
  mobile = false;

  @Inject()
  private globalWindow!: () => Window;

  created() {
    this.refreshMobile();
    this.sidebarExpanded = !this.mobile;
    this.globalWindow().addEventListener('resize', this.refreshMobile);
  }

  beforeDestroy() {
    this.globalWindow().removeEventListener('resize', this.refreshMobile);
  }

  expandSidebar() {
    this.sidebarExpanded = true;
  }

  reduceSidebar() {
    this.sidebarExpanded = false;
  }

  refreshMobile() {
    this.mobile = isMobile(this.globalWindow(), MOBILE_BREAKPOINT);
  }
}
